import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import ConnectModal from './ConnectModal';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components'
import { Link } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import TermsOfUse from './TermsOfUse';


function Header() {

  const {account,connect} = useWallet();

  const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, #09121D 3.92%, rgba(9, 18, 29, 0) 36.79%, #09121D 83.98%), url("../../assets/images/backgroup/bg_pagetitle.png"), center, center, no-repeat;
  mix-blend-mode: luminosity;
  background-position: center, center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.9;
    `;

    const PageTitle = styled.section`
    padding: 146px 0 59px;
    position: relative;
      `;


	const ConnectWalletOnclick = ()=>{

        const ethereum = window.ethereum;
        if(ethereum){

         
          if(!account){
              connect("injected");
            }        

        } else {
          toast.error("Please Install Metamask");
        }
        
      }
 
  return (
    <>
       {/* Header */}
       <Toaster
		     position="top-right"
		    reverseOrder={false}
	    	/>
            <TermsOfUse/>
        <header id="header_main" className="header">
        <div className="container">
        <div id="site-header-inner">
        <nav id="main-nav" className="main-nav">
            <ul id="menu-primary-menu" className="menu">
              
            <li className="menu-item ">
                <Link to='/'>Home</Link>
              </li>

            <li className="menu-item ">
                  <Link to='/about'>About</Link>
              </li>
              
              <li className="menu-item ">
                  <Link to='/contact'>Contact</Link>
              </li>
            </ul>
        </nav>

            <div className="header__logo">
            <Link to="/"><img src="/assets/images/logo.png" alt="" /></Link>
            </div>
 
            <a href="#" style={{marginRight:"0px"}} className="tf-button style1" onClick={ConnectWalletOnclick}>
            <span>  {account ? ((account).substring(0, 8) + "..." + (account).substring((account).length - 4)) : "Connect Wallet"}
                 </span>
            </a>
            <div className="mobile-button"><span /></div>  
        </div>
        </div>
        </header>

            {!account ? (<ConnectModal/>) : null}    
        
        {/* end Header */}

        <PageTitle >
        <br/><br/>
             <Overlay /> 
         </PageTitle>
    </>
  );
}

export default Header;


